import {useEffect} from "react";
import {
    Box,
    Dialog,
    IconButton,
    Slide,
    Theme,
    Toolbar,
    Typography,
} from "@mui/material";
import {CloseRounded} from "@mui/icons-material";


export const PopupHandlerScreen = () => {

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status" || "error");

    const broadcastChannel = new BroadcastChannel("oauth_channel");
    broadcastChannel.postMessage(
            {
              type: "OAUTH_RESULT",
              status
            }
    )
    broadcastChannel.close();

    window.close();


  }, [])


  return (
     <Box>
        Connecting your email...
     </Box>

);
};
